package com.swetdot.swetgram.data.premium

import com.swetdot.swetgram.data.api.ApiClient
import com.swetdot.swetgram.domain.PremiumAccess
import com.swetdot.swetgram.domain.PremiumAccessLimits
import com.swetdot.swetgram.domain.PremiumAccessStatus
import com.swetdot.swetgram.protocol.dto.PremiumEntitlement
import com.swetdot.swetgram.protocol.dto.GooglePlayPurchaseRequest
import com.swetdot.swetgram.protocol.dto.PremiumStatus
import com.swetdot.swetgram.protocol.dto.UpdatePremiumPreferencesRequest
import io.ktor.client.request.setBody

class PremiumRepository(private val api: ApiClient) {
    suspend fun get(): PremiumAccess =
        api.get<PremiumEntitlement>("me/premium").toDomain()

    /** Returns access only after the backend verifies and atomically binds the Play token. */
    suspend fun verifyGooglePlayPurchase(purchaseToken: String): PremiumAccess =
        api.post<PremiumEntitlement>("billing/google-play/purchases") {
            setBody(
                GooglePlayPurchaseRequest(
                    productId = "swetgram_black",
                    purchaseToken = purchaseToken,
                ),
            )
        }.toDomain()

    suspend fun updateBadgeVisibility(visible: Boolean): PremiumAccess =
        api.patch<PremiumEntitlement>("me/premium") {
            setBody(UpdatePremiumPreferencesRequest(visible))
        }.toDomain()
}

private fun PremiumEntitlement.toDomain() = PremiumAccess(
    status = when (status) {
        PremiumStatus.FREE -> PremiumAccessStatus.FREE
        PremiumStatus.PENDING -> PremiumAccessStatus.PENDING
        PremiumStatus.ACTIVE -> PremiumAccessStatus.ACTIVE
        PremiumStatus.GRACE_PERIOD -> PremiumAccessStatus.GRACE_PERIOD
        PremiumStatus.ON_HOLD -> PremiumAccessStatus.ON_HOLD
        PremiumStatus.PAUSED -> PremiumAccessStatus.PAUSED
        PremiumStatus.EXPIRED -> PremiumAccessStatus.EXPIRED
        PremiumStatus.REVOKED -> PremiumAccessStatus.REVOKED
        PremiumStatus.UNKNOWN -> PremiumAccessStatus.UNKNOWN
    },
    active = active,
    eligible = eligible,
    salesEnabled = salesEnabled,
    productId = productId,
    basePlanId = basePlanId,
    currentPeriodEnd = currentPeriodEnd,
    trialEnd = trialEnd,
    autoRenewing = autoRenewing,
    badgeVisible = badgeVisible,
    limits = PremiumAccessLimits(
        pinnedChats = limits.pinnedChats,
        chatFolders = limits.chatFolders,
        accounts = limits.accounts,
        bioCharacters = limits.bioCharacters,
        profileLinks = limits.profileLinks,
        profileGalleryPhotos = limits.profileGalleryPhotos,
        voiceMessageSeconds = limits.voiceMessageSeconds,
        fileBytes = limits.fileBytes,
        storageBytes = limits.storageBytes,
        scheduledMessages = limits.scheduledMessages,
        premiumGroupStyles = limits.premiumGroupStyles,
        discoverAnalyticsDays = limits.discoverAnalyticsDays,
    ),
    version = version,
)
